import {
  SET_COMMON_CONFIGS,
  PAYMENT_STATUS_MODAL_SHOW,
  PAYMENT_STATUS_WINDOW_CLOSE,
  PAYMENT_TYPES_MODAL_SHOW,
  PAYMENT_STATUS_DATA,
  CUSTOMERS_ADDEDIT_MODAL_SHOW,
  IS_LOYALTY_ENABLED,
  LOAD_CASH_OPEN_CLOSE_SUMMARY,
  HISTORY_MODAL_CUS_SEARCH,
  VARIANT_MODAL_SHOW,
  VARIANT_SELECTED_PROD_ID,
  STOCK_VIEW_DETAILS_DATA,
  LOADER_LOGIN,
  STORE_INFO,
  IS_DAY_PAST,
  IS_SELECT_REG,
  SELECTED_REG,
  SELECTED_OUTLET,
  CURR_PAGE_URL,
  IS_STORE_EXPIRED,
  IS_OUTLET_INVENTORY_WARN,
  SUB_PERMISSIONS,
  IS_TRIAL,
  IS_ENTERPRISE,
  CONFIGSHOWSELLATTRIBUTE,
  CONFIGSHOWSELLLAYOUT,
  NotificationBar,
  NotificationHead,
  NotficationBGColor,
  ShowHeaderFooter,
  ShowContactUs,
  ContactUsLoader,
  ShowAttribDrop,
  DropDownStates,
  AttribGroups,
  ShowAttribSaleData,
  OPENCLOSEPRINTDATA,
  SHOWPRINTOPENCLOSE,
  ISONLINE,
  ISMOBAPP,
  GETAPPDATA,
  GETAPPNETWORK,
  ENABLEAllPOSLAYOUTS
} from '../../constants/ActionTypes'

const INIT_STATE = {
  pageCommonConfigs: {},
  showPaymentStatusModal: false,
  statusPaymentWindowClose: false,
  paymentTypesModalShow: false,
  paymentStatusData: {},
  customersAddEditModalShow: false,
  getIsLoyaltyEnable: false,
  getPaySummary: [],
  getHistoryCusSearch: {},
  getIsShowVariantModal: false,
  getVariantSelectedProdID: '',
  getStockViewDetailsData: {},
  getLoginLoader: false,
  getStoreInfo: {},
  getIsDayPast: false,
  getIsSelectReg: false,
  getSelectedOutlet: '',
  getSelectedReggg: '',
  getCurrPageURL: '',
  getIsStoreExpired: false,
  getIsOutInvWarn: false,
  getSubPerm: [],
  getIsTrial: false,
  getIsEnterprise: false,
  getConfigSellAttribute: false,
  getConfigSellLayout: false,
  notificationBar: false,
  notificationHead: '',
  notificationBGColor: '#858283', // gray color
  showHeaderFooter: false,
  showContactUs: false,
  showContactLoader: false,
  showAttribDrop: 0,
  dropDownStates: [],
  getSellAttributeGroupsData: [],
  saleAttribData: [],
  printData: {},
  showPrint: false,
  isOnline: true,
  isMobApp: false,
  appData: {},
  isAppOnline: {},
  getEnableAllPOSLayouts : false,
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_COMMON_CONFIGS: {
      return {
        ...state,
        pageCommonConfigs: action.payload
      }
    }
    case PAYMENT_STATUS_MODAL_SHOW: {
      return {
        ...state,
        showPaymentStatusModal: action.payload
      }
    }
    case PAYMENT_STATUS_WINDOW_CLOSE: {
      return {
        ...state,
        statusPaymentWindowClose: action.payload
      }
    }
    case PAYMENT_TYPES_MODAL_SHOW: {
      return {
        ...state,
        paymentTypesModalShow: action.payload
      }
    }
    case PAYMENT_STATUS_DATA: {
      return {
        ...state,
        paymentStatusData: action.payload
      }
    }
    case CUSTOMERS_ADDEDIT_MODAL_SHOW: {
      return {
        ...state,
        customersAddEditModalShow: action.payload
      }
    }
    case IS_LOYALTY_ENABLED: {
      return {
        ...state,
        getIsLoyaltyEnable: action.payload
      }
    }
    case LOAD_CASH_OPEN_CLOSE_SUMMARY: {
      return {
        ...state,
        getPaySummary: action.payload
      }
    }
    case HISTORY_MODAL_CUS_SEARCH: {
      return {
        ...state,
        getHistoryCusSearch: action.payload
      }
    }
    case VARIANT_MODAL_SHOW: {
      return {
        ...state,
        getIsShowVariantModal: action.payload
      }
    }
    case VARIANT_SELECTED_PROD_ID: {
      return {
        ...state,
        getVariantSelectedProdID: action.payload
      }
    }
    case STOCK_VIEW_DETAILS_DATA: {
      return {
        ...state,
        getStockViewDetailsData: action.payload
      }
    }
    case STORE_INFO: {
      return {
        ...state,
        getStoreInfo: action.payload
      }
    }
    case IS_DAY_PAST: {
      return {
        ...state,
        getIsDayPast: action.payload
      }
    }
    case IS_SELECT_REG: {
      return {
        ...state,
        getIsSelectReg: action.payload
      }
    }
    case LOADER_LOGIN: {
      return {
        ...state,
        getLoginLoader: action.payload
      }
    }
    case SELECTED_REG: {
      return {
        ...state,
        getSelectedReggg: action.payload
      }
    }
    case SELECTED_OUTLET: {
      return {
        ...state,
        getSelectedOutlet: action.payload
      }
    }
    case CURR_PAGE_URL: {
      return {
        ...state,
        getCurrPageURL: action.payload
      }
    }
    case IS_STORE_EXPIRED: {
      return {
        ...state,
        getIsStoreExpired: action.payload
      }
    }
    case IS_OUTLET_INVENTORY_WARN: {
      return {
        ...state,
        getIsOutInvWarn: action.payload
      }
    }
    case SUB_PERMISSIONS: {
      return {
        ...state,
        getSubPerm: action.payload
      }
    }
    case IS_TRIAL: {
      return {
        ...state,
        getIsTrial: action.payload
      }
    }
    case IS_ENTERPRISE: {
      return {
        ...state,
        getIsEnterprise: action.payload
      }
    }
    case CONFIGSHOWSELLATTRIBUTE: {
      return {
        ...state,
        getConfigSellAttribute: action.payload
      }
    }
    case CONFIGSHOWSELLLAYOUT: {
      return {
        ...state,
        getConfigSellLayout: action.payload
      }
    }
    case ENABLEAllPOSLAYOUTS: {
      return {
        ...state,
        getEnableAllPOSLayouts : action.payload
      }
    }
    case NotificationBar: {
      return {
        ...state,
        notificationBar: action.payload
      }
    }
    case NotificationHead: {
      return {
        ...state,
        notificationHead: action.payload
      }
    }
    case NotficationBGColor: {
      return {
        ...state,
        notificationBGColor: action.payload
      }
    }
    case ShowHeaderFooter: {
      return {
        ...state,
        showHeaderFooter: action.payload
      }
    }
    case ShowContactUs: {
      return {
        ...state,
        showContactUs: action.payload
      }
    }
    case ContactUsLoader: {
      return {
        ...state,
        showContactLoader: action.payload
      }
    }
    case ShowAttribDrop: {
      return {
        ...state,
        showAttribDrop: action.payload
      }
    }
    case DropDownStates: {
      return {
        ...state,
        dropDownStates: action.payload
      }
    }
    case AttribGroups: {
      return {
        ...state,
        getSellAttributeGroupsData: action.payload
      }
    }
    case ShowAttribSaleData: {
      return {
        ...state,
        saleAttribData: action.payload
      }
    }
    case OPENCLOSEPRINTDATA: {
      return {
        ...state,
        printData: action.payload
      }
    }
    case SHOWPRINTOPENCLOSE: {
      return {
        ...state,
        showPrint: action.payload
      }
    }
    case ISONLINE: {
      return {
        ...state,
        isOnline: action.payload
      }
    }
    // case ISMOBAPP: {
    //   return {
    //     ...state,
    //     isMobApp: action.payload
    //   }
    // }
    case GETAPPDATA: {
      return {
        ...state,
        appData: action.payload
      }
    }
    case GETAPPNETWORK: {
      return {
        ...state,
        isAppOnline: action.payload
      }
    }
    default:
      return state
  }
}
